import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import s from './index.css';
import { animateScrollTo, trackEventLog } from '../../../core/utils'

class Sidebar extends React.Component {
  static handleScroll() {
    const scrollTop = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop
                || 0
    if (scrollTop > 0) document.getElementById('backTop').style.display = 'block'
    else document.getElementById('backTop').style.display = 'none'
  }

  static handleClick() {
    trackEventLog('w/slidebar/top')
    if (document.body.scrollTop === 0) { // IE 9
      document.documentElement.scrollTop = 0
    } else {
      animateScrollTo(document.body, 0)
    }
  }

  constructor(props) {
    super(props)
    this.openCustomerService = this.openCustomerService.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', Sidebar.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', Sidebar.handleScroll)
  }

  openCustomerService() {
    trackEventLog('online_service_click', { type: 0 })
    const { status } = this.props
    const conf = {
      uid: status.id || '',
      data: JSON.stringify([
        { key: 'real_name', value: status.nickname },
        { key: 'mobile_phone', value: status.mobile },
        { index: 0, key: 'account', label: '账号', value: status.id },
        { index: 1, key: 'qq', label: 'qq', value: status.qq },
      ]),
    }
    window.ysf && window.ysf.config && window.ysf.config(conf)  // eslint-disable-line
    window.ysf && window.ysf.open && window.ysf.open()  // eslint-disable-line
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.service}>
          <span onClick={() => this.openCustomerService()} role="none">
            <div className={s.icon} />
            <p>在线<br />客服</p>
          </span>
        </div>
        <div className={s.download}>
          <div className={s.icon} />
          <p>APP<br />下载</p>
          <div className={s.QRcode}>
            <img src="https://oimageb4.ydstatic.com/image?id=-6617113928986162471&product=xue" alt="精品课二维码" />
            <p>扫描二维码<br />下载有道精品课</p>
          </div>
        </div>
        <div id="backTop" className={s.backTop}>
          {/* eslint-disable*/}
          <a href="javascript:void(0)" onClick={Sidebar.handleClick}>
            <div className={s.icon} />
            <p>返回<br />顶部</p>
          </a>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  status: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    status: state.user.status,
  };
}

export default connect(mapStateToProps)(withStyles(s)(Sidebar));



// WEBPACK FOOTER //
// ./src/components/global/Sidebar/index.js